import Breadcrumb from './Breadcrumb.svg'
import Button from './Button.svg'
import Card from './Card.svg'
import Checkbox from './Checkbox.svg'
import CollectionEditor from './CollectionEditor.svg'
import Container from './Container.svg'
import Content from './Content.svg'
import CustomBlock from './CustomBlock.svg'
import CustomControl from './CustomControl.svg'
import DatePicker from './DatePicker.svg'
import Default from './Default.svg'
import Dropdown from './Dropdown.svg'
import Dropzone from './Dropzone.svg'
import ErrorMessage from './ErrorMessage.svg'
import Footer from './Footer.svg'
import Grid from './Grid.svg'
import GridLayout from './GridLayout.svg'
import GridView from './GridView.svg'
import Header from './Header.svg'
import Image from './Image.svg'
import Input from './Input.svg'
import Label from './Label.svg'
import Link from './Link.svg'
import Menu from './Menu.svg'
import Message from './Message.svg'
import NumberFormat from './NumberFormat.svg'
import PatternFormat from './PatternFormat.svg'
import ProgressCircle from './ProgressCircle.svg'
import ProgressLine from './ProgressLine.svg'
import RadioGroup from './RadioGroup.svg'
import Repeater from './Repeater.svg'
import RichTextEditor from './RichTextEditor.svg'
import Search from './Search.svg'
import Sidebar from './Sidebar.svg'
import Signature from './Signature.svg'
import Sparks from './Sparks.svg'
import StaticContent from './StaticContent.svg'
import Tab from './Tab.svg'
import TextArea from './TextArea.svg'
import TimePicker from './TimePicker.svg'
import Toggle from './Toggle.svg'
import Tooltip from './Tooltip.svg'
import TreePicker from './TreePicker.svg'
import Uploader from './Uploader.svg'

export const icons = {
  Breadcrumb,
  Button,
  Card,
  Checkbox,
  CollectionEditor,
  Container,
  Content,
  CustomBlock,
  CustomControl,
  DatePicker,
  Default,
  Dropdown,
  Dropzone,
  ErrorMessage,
  Grid,
  GridLayout,
  GridView,
  Image,
  Input,
  Label,
  Link,
  Footer,
  Header,
  Sidebar,
  Menu,
  Message,
  NumberFormat,
  PatternFormat,
  ProgressCircle,
  ProgressLine,
  RadioGroup,
  Repeater,
  RichTextEditor,
  Search,
  Signature,
  Sparks,
  StaticContent,
  Tab,
  TextArea,
  TimePicker,
  Toggle,
  Tooltip,
  TreePicker,
  Uploader
}
